import { cva, type VariantProps } from 'class-variance-authority'
export { default as Checkbox } from './Checkbox.vue'

export const checkboxVariants = cva(
  'peer h-4 w-4 shrink-0 rounded-sm border ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:text-primary-foreground',
  {
    variants: {
      variant: {
        default: 'border-primary data-[state=checked]:bg-primary',
        internal: 'border-internal data-[state=checked]:bg-internal',
        dora: 'border-accent-hover data-[state=checked]:bg-pink-600',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export type CheckboxVariants = VariantProps<typeof checkboxVariants>
